/* @flow */
import ConfirmDialog from 'components/ConfirmDialog.jsx';
import LayerTrigger from 'components/LayerTrigger.jsx';
import Menu from 'components/Menu.jsx';
import ModalMenuItem from 'components/ModalMenuItem.jsx';
import MenuItem from 'components/MenuItem.jsx';
import Activity, { ACTIVITY_PRINTED_MSG } from 'entities/Activity';
import ActivityActions from 'payments/actions/ActivityActions';
import React from 'react';
import ToastActions from 'actions/ToastActions';

export default React.createClass({
  propTypes: {
    activity: React.PropTypes.instanceOf(Activity).isRequired,
  },

  getCloseConfirmDialog() {
    return (
      <ConfirmDialog
        size="xsmall"
        title={'Close this activity?'}
        subtext={`Once your activity is closed, participants won’t
        be able to send you money. You can still
        deposit funds to your bank account.`}
        actionButtonText="Close"
        cancelButtonText="Cancel"
        onConfirm={() => {
          ActivityActions.close(this.props.activity).then(
            () => ToastActions.showSuccessToast('Activity is now closed'),
            () => ToastActions.showDefaultErrorToast(),
          );
        }}
      />
    );
  },

  printActivity() {
    Activity.export(this.props.activity.id)
      .then(
        () => ToastActions.showSuccessToast(ACTIVITY_PRINTED_MSG),
        () => ToastActions.showDefaultErrorToast()
      );
  },

  renderMenu() {
    return (
      <Menu>
        {!this.props.activity.isClosed() &&
          <ModalMenuItem modal={this.getCloseConfirmDialog()}>
            Close activity
          </ModalMenuItem>
        }
        <MenuItem onClick={() => this.printActivity()}>
          Print Activity
        </MenuItem>
      </Menu>
    );
  },

  render() {
    return (
      <LayerTrigger
        layer={this.renderMenu()}
        trigger="click"
        alignment="right"
        placement="bottom">
        {this.props.children}
      </LayerTrigger>
    );
  },
});



// WEBPACK FOOTER //
// ./src/payments/components/ActivitiesActionsLayer.jsx